import styled from 'styled-components';

export const Title = styled.div`
	font-weight: 500;
	font-size: 19px;
	color: black;
	flex: 1;
`;

export const Header = styled.div`
	display: flex;
	align-items: center;
`;

export const ButtonWrapper = styled.div`
	margin-right: 16px;

	&:last-child {
		margin-right: 0;
	}
`;
